import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function PageTitle({ children }) {
  return <Typography variant="h4" color="default">{children}</Typography>
}
